module.exports = __webpack_public_path__ + "img/个性化定制方案 拷贝 2@2x.046c4825.png";